import React from 'react'

const HolidayGifts = () => {
  return (
    <div>HolidayGifts</div>
  )
}

export default HolidayGifts